/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_date_range.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `date_range` value.
 * Strings are parsed as a date range in the format `start..end`, where `start` and `end` are dates in ISO format. The range is half-open `[start, end)`.
 *
 * @example
 * ROW str = "2020-01-01T00:00:00.000Z..2021-01-01T00:00:00.000Z"
 * | EVAL range = TO_DATE_RANGE(str)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_date_range',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'date_range',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_range',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_range',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date_range',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
